/**
 * RISKS-SPACE.CONTEXT
 * Les pages risques servent l'app (/risks) et le document unique (/document/:id), en lecture seule.
 * Les liens passent par getPath pour rester dans l'espace courant.
 */
import { createContext, useContext } from "react"

interface RisksSpace {
  isReadonly: boolean
  getPath: (path: string) => string
}

const RisksSpaceContext = createContext<RisksSpace>({
  isReadonly: false,
  getPath: (path) => `/risks${path}`
})

export const RisksSpaceProvider = RisksSpaceContext.Provider

export function useRisksSpace() {
  return useContext(RisksSpaceContext)
}
